import PropTypes from "prop-types";
import React from "react";
import { Carousel } from "@mantine/carousel";
import "@mantine/carousel/styles.css";
import { Box, Flex, Image, Text, useMantineTheme } from "@mantine/core";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";

const CustomerReviews = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: landingClasses } = useStylesLanding();
  return (
    <Box component="section" className={landingClasses.customerReviews}>
      <Box className={landingClasses.landingContainer}>
        <Box className={landingClasses.customerReviewsTitle}>
          Customer Reviews
        </Box>

        <Flex
          align={theme.flex.align.center}
          justify={theme.flex.justify.between}
        >
          <Box className={landingClasses.customerReviewsBlocksWrap}>
            <Carousel
              className="blocks-reviews-slider-slides reviews-slides-js rb-display-flex reviews"
              withIndicators
              slideSize="100%"
              slideGap="md"
              loop="true"
              align="start"
              slidesToScroll="1"
              nextControlIcon={
                <Image
                  w="2.8em"
                  src={`${staticBasePath}public/images/svg/landing_reviews-arrow.svg`}
                  alt="Arrow left"
                />
              }
              previousControlIcon={
                <Image
                  w="2.8em"
                  src={`${staticBasePath}public/images/svg/landing_reviews-arrow.svg`}
                  alt="Arrow right"
                />
              }
            >
              <Carousel.Slide>
                <Box className={landingClasses.customerReviewsBlocksItem}>
                  <Text>
                    &quot;If a data vendor is even considering using
                    validityBase, we want to know about them. It sends a very
                    positive signal about the quality of their data.&quot;
                  </Text>

                  <Flex
                    align={theme.flex.align.center}
                    className={landingClasses.customerReviewsBlocksItemAuthor}
                  >
                    <Box>
                      <Image
                        w="3.2em"
                        src={`${staticBasePath}public/images/png/CIO-image-48x48.png`}
                        alt="Robert Fox"
                      />
                    </Box>

                    <Box
                      className={
                        landingClasses.customerReviewsBlocksItemAuthorName
                      }
                    >
                      CIO
                      <Text component="span">
                        London ML/AI quantitative fund
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Carousel.Slide>
              <Carousel.Slide>
                <Box className={landingClasses.customerReviewsBlocksItem}>
                  <Text>
                    &quot;vBase really helps a newer data product like mine gain
                    credibility and compete with more established
                    companies.&quot;
                  </Text>

                  <Flex
                    align={theme.flex.align.center}
                    className={landingClasses.customerReviewsBlocksItemAuthor}
                  >
                    <Box>
                      <Image
                        w="3.2em"
                        src={`${staticBasePath}public/images/png/survey-icon-1-48x48.png`}
                        alt="Robert Fox"
                      />
                    </Box>

                    <Box
                      className={
                        landingClasses.customerReviewsBlocksItemAuthorName
                      }
                    >
                      Founder
                      <Text component="span">
                        US financial survey data company
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Carousel.Slide>
              <Carousel.Slide>
                <Box className={landingClasses.customerReviewsBlocksItem}>
                  <Text>
                    &quot;vBase is a great tool for creating a credible track
                    record. Thank you.&quot;
                  </Text>

                  <Flex
                    align={theme.flex.align.center}
                    className={landingClasses.customerReviewsBlocksItemAuthor}
                  >
                    <Box>
                      <Image
                        w="3.2em"
                        src={`${staticBasePath}public/images/png/quant-fund-icon-48x48.png`}
                        alt="Robert Fox"
                      />
                    </Box>

                    <Box
                      className={
                        landingClasses.customerReviewsBlocksItemAuthorName
                      }
                    >
                      Founder
                      <Text component="span">US-based quant fund</Text>
                    </Box>
                  </Flex>
                </Box>
              </Carousel.Slide>
            </Carousel>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
CustomerReviews.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
};
export default CustomerReviews;
